export default "__VITE_ASSET__BV7oCeTV__"